import styled from "styled-components";
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import pages from "../../constants/pages";
import { Reject } from "../css components/Button";
import { colors } from "../css components/Style";
import Logo from "../../assets/auth images/Campaign.png";
import { useAxios, useComponent } from "../../hooks";
import { alert } from "../../redux/slices/alertSlice";
import { signOutMember } from "../../redux/slices/memberSlice";
import WelcomeCards from "./login user components/WelcomeCards";
import Powered from "../../assets/grow_logo-removebg-preview.png";
import ENV from "../../config/config";

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

const InnerWrapper = styled.div`
  padding: 40px;
  text-align: center;
`;

const Typo = styled(Typography)`
  font-weight: 400;
  font-size: 1.5rem;
  margin-top: 10px;
`;

export default function WelcomeUnverified() {
  const axios = useAxios();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loader } = useComponent();

  const [steps, setStep] = useState({});
  const [status, setStatus] = useState(false);
  const [verification, setVerification] = useState({
    brand: false,
    admin: false,
  });
  const userID = sessionStorage.getItem("userID");
  const brandID = sessionStorage.getItem("brandID");
  const role = sessionStorage.getItem("role");

  const { parentState } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    axios({
      url: "/user/info?userId=" + userID,
      disableRedirect: true,
    }).then((res) => {
      if (res.status) {
        sessionStorage.setItem("ladder", JSON.stringify(res.data?.steps));
        setStep(res.data.steps);
        if (parseInt(res.data.brand?.brand_id) === parseInt(brandID)) {
          if (res.data.brand?.is_brand_verified === 1) {
            setVerification({
              brand: true,
            });
          }
          if (res.data.brand?.is_brand_verified === 2) {
            dispatch(
              alert({
                type: "info",
                message: "Brand has been rejected by the admin!",
              })
            );
            dispatch(signOutMember());
            navigate(pages.signIn.route);
          }
        }
      }
    });
  }, [axios, userID, loader, dispatch, navigate, brandID]);

  function checkStatus() {
    setStatus(true);
    axios({
      url: "/user/info?userId=" + userID,
      disableRedirect: true,
    }).then((res) => {
      if (res.status) {
        if (parseInt(res.data.brand?.brand_id) === parseInt(brandID)) {
          if (res.data.brand?.is_brand_verified === 0) {
            let message = "Brand hasn't been approved by the admin yet!";

            if (
              !res.data.brand?.get_agreement ||
              !res.data.brand?.sign_agreement
            ) {
              message = "Agreement process is pending from your side";
            }

            dispatch(
              alert({
                type: "warning",
                message: message,
              })
            );
          }

          if (res.data.brand?.is_brand_verified === 1) {
            dispatch(signOutMember());

            setVerification({
              brand: true,
            });

            dispatch(
              alert({
                type: "success",
                message: "Brand has been approved by the admin!",
              })
            );
          }

          if (res.data.brand?.is_brand_verified === 2) {
            dispatch(
              alert({
                type: "info",
                message: "Brand has been rejected by the admin!",
              })
            );
            dispatch(signOutMember());
            navigate(pages.signIn.route);
          }
        }
        setStatus(false);
      }
    });
  }

  return (
    <Wrapper>
      <Box sx={{ position: "relative" }}>
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: 200,
            height: 200,
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              width: 200,
              height: 200,
              borderRadius: "0 0 100% 0",
              backgroundColor: "#A58ADD",
            }}
          />

          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: 145,
              height: 145, // reduced height
              borderRadius: "0 0 100% 0",
              backgroundColor: "#7B5CC3",
            }}
          />

          <Box
            component="img"
            src={Logo}
            alt="rotated icon"
            sx={{
              position: "absolute",
              top: -39,
              left: -48,
              width: 130,
              height: 125,
              transform: "rotate(43deg)",
            }}
          />
        </Box>
      </Box>

      <InnerWrapper>
        <Typography
          className="publicis-text"
          style={{ color: colors.publicisBlue }}
        >
          PUBLICIS
          <Typography
            className="publicis-text"
            style={{ color: colors.publicisSlateBlue }}
          >
            &nbsp;ID
          </Typography>
        </Typography>

        <Typo>Brand & Company Details</Typo>
        <Typography fontSize={"20px"} className="font">
          Fill in the essential information to set up your brand and company
          profile.
        </Typography>

        <WelcomeCards steps={steps} verification={verification} />

        {steps.step2 && steps.step3 && !verification.agency && (
          <div className="admin-status">
            <Typography
              style={{
                textAlign: "center",
                fontWeight: "600",
              }}
            >
              Your account is waiting for the admin approval!
              <Typography
                style={{ cursor: "pointer" }}
                variant="button"
                color={colors.publicisBlue}
                onClick={checkStatus}
                disabled={status}
              >
                {" "}
                Click to check status.
              </Typography>
            </Typography>
          </div>
        )}
      </InnerWrapper>

      {steps.step2 && steps.step3 && verification.agency && (
        <div className="admin-approve-status">
          <Typography
            style={{
              textAlign: "center",
              fontWeight: "600",
            }}
          >
            Your account has been approved by the admin. Click here to{" "}
            <Typography
              style={{ cursor: "pointer" }}
              variant="button"
              color={colors.publicisBlue}
              onClick={() => {
                dispatch(signOutMember());
                navigate(pages.signIn.route);
              }}
            >
              Login
            </Typography>
          </Typography>
        </div>
      )}

      <div style={{ bottom: "-128px" }} className="bottom-div">
        <Reject
          style={{ float: "left" }}
          onClick={() => {
            dispatch(signOutMember());
            if (ENV === "dev") {
              window.location = "https://buz.igrowthos.ai/";
            }

            if (ENV === "main") {
              window.location = "https://www.growthosin.ai";
            }
          }}
        >
          Logout
        </Reject>

        <div style={{ alignSelf: "center", display: "flex" }}>
          <Typography className="font" variant="button">
            Powered By
          </Typography>
          <img
            src={Powered}
            alt="!"
            style={{ height: "35px", position: "relative", top: "-2px" }}
          />
        </div>

        <div></div>
      </div>
    </Wrapper>
  );
}
